var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72701 7.2756C9.05398 9.60192 9.58186 6.91063 11.0635 8.39118C12.4918 9.81915 13.3128 10.1052 11.5031 11.9145C11.2764 12.0966 9.8361 14.2884 4.77451 9.22818C-0.2877 4.16737 1.90275 2.72563 2.08498 2.49901C3.89908 0.684784 4.18025 1.51051 5.60861 2.93848C7.09021 4.41966 4.40005 4.94928 6.72701 7.2756Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f39872434c815bfdef5d132eb016d526.svg";
export { ForwardRef as ReactComponent };